import Procedure from './Procedure'

export default Procedure
